"use strict";

(function () {
  'use strict';

  function relativeDate(Moment, DateService) {
    return function (dateStr) {
      var now = Moment().startOf('day');

      if (dateStr) {
        var m1 = Moment(DateService.formatSlashesToDashes(dateStr)).utc();
        Moment.updateLocale('en', {
          relativeTime: {
            future: '%s',
            past: '%d ago',
            s: 'today',
            m: 'today',
            mm: 'today',
            h: 'today',
            hh: 'today',
            d: '%d day',
            dd: '%d days',
            M: '%d month',
            MM: '%d months',
            y: '%d year',
            yy: '%d years'
          }
        });
        Moment.relativeTimeThreshold('d', 31);
        return m1.from(now, true);
      } else {
        return dateStr;
      }
    };
  }

  function relativeCheckOut(Moment, DateService) {
    return function (dateStr) {
      var now = Moment().startOf('day');

      if (dateStr) {
        var m1 = Moment(DateService.formatSlashesToDashes(dateStr)).utc();
        Moment.updateLocale('en', {
          relativeTime: {
            future: '%s',
            past: '%d ago',
            s: 'today is check out',
            m: 'today is check out',
            mm: 'today is check out',
            h: 'today is check out',
            hh: 'today is check out',
            d: '%d day until check out',
            dd: '%d days until check out',
            M: '%d month until check out',
            MM: '%d months until check out',
            y: '%d year until check out',
            yy: '%d years until check out'
          }
        });
        Moment.relativeTimeThreshold('d', 31);
        return m1.from(now, true);
      } else {
        return dateStr;
      }
    };
  }

  function relativeCheckIn(Moment, DateService) {
    return function (dateStr) {
      var now = Moment().startOf('day');

      if (dateStr) {
        var m1 = Moment(DateService.formatSlashesToDashes(dateStr)).utc();
        Moment.updateLocale('en', {
          relativeTime: {
            future: '%s',
            past: '%d ago',
            s: 'today is check in',
            m: 'today is check in',
            mm: 'today is check in',
            h: 'today is check in',
            hh: 'today is check in',
            d: '%d day until check in',
            dd: '%d days until check in',
            M: '%d month until check in',
            MM: '%d months until check in',
            y: '%d year until check in',
            yy: '%d years until check in'
          }
        });
        Moment.relativeTimeThreshold('d', 31);
        return m1.from(now, true);
      } else {
        return dateStr;
      }
    };
  }

  relativeDate.$inject = ['Moment', 'DateService'];
  relativeCheckIn.$inject = ['Moment', 'DateService'];
  relativeCheckOut.$inject = ['Moment', 'DateService'];
  angular.module('filter.relative-date', []).filter('relativeDate', relativeDate).filter('relativeCheckOut', relativeCheckOut).filter('relativeCheckIn', relativeCheckIn);
})();